<app-nav-cliente></app-nav-cliente>
<div class="container-fluid">
    <div class="row">
        <div class="col-lg-1"></div>
        <div class="col-lg-10">
            <h5>Fotos Personales</h5>
            <div class="row">
                <div class="col-lg-4" *ngFor="let fotoM of fotos">
                    <img src="{{environment}}{{fotoM.imagen}}" width="100%"><br>
                    <p class="center bold">{{fotoM.nombre}}</p>
                    <p class="center">
                        <button class="btn btn-success" (click)="descargarImagen(fotoM.imagen)">Descargar</button>
                    </p>
                </div>
            </div>
        </div>
    </div>
    <br>
    <div class="row">
        <div class="col-lg-1"></div>
        <div class="col-lg-10">
            <h5>Fotos Grupales</h5>

            <a href="{{link_drive}}" target="_blank">Link drive fotos</a>
            <div class="row">
                <div class="col-lg-4" *ngFor="let foto1 of fotosG">
                    <br>
                    <img src="{{environment}}{{foto1.imagen}}" width="100%"><br>
                    <!-- <a download="{{foto1.imagen}}" href="{{environment}}{{foto1.imagen}}">
                        Descargar
                    </a> -->
                    <p class="center">
                        <button class="btn btn-success" (click)="descargarImagen(foto1.imagen)">Descargar</button>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>